// src/components/ui/FilterButton.tsx
import React from 'react';

interface FilterButtonProps {
  onClick: () => void;
  children: React.ReactNode;
  disabled?: boolean;
  active?: boolean;
}

const FilterButton: React.FC<FilterButtonProps> = ({
  onClick,
  children,
  disabled = false,
  active = false,
}) => {
  const base = 'px-6 py-2 font-semibold rounded-lg transition-colors';
  const enabledClasses = active
    ? 'bg-blue-600 text-white hover:bg-blue-700'
    : 'bg-gray-800 text-white hover:bg-gray-600';
  const disabledClasses = disabled
    ? 'opacity-50 cursor-not-allowed hover:bg-gray-800'
    : '';

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${base} ${enabledClasses} ${disabledClasses}`}
    >
      {children}
    </button>
  );
};

export default FilterButton;
